import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { getOfficeLocations } from '../../actions/userActions/officelocationAction'
import Loader from '../subComponents/Loader'
import ServerSideSearch from '../subComponents/search/ServerSideSearch'
import Pagination from '../paginatioin/pagination'
import './OfficeLocation.css'
import AddButton from '../subComponents/buttons/AddButton'
import { IconButton, Tooltip } from "@mui/material";
import EditButton from '../subComponents/buttons/EditButton'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CustomButton from '../subComponents/buttons/CustomButton'
import DynamicTable from '../reuse_components/DynamicTable'
import CustomPagination from '../subComponents/pagination/CustomPagination'
import SearchInput from '../subComponents/search/SearchInput'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import Heading6Regular from '../designSystem/Heading6Regular'
import { Download } from 'lucide-react';
import { downloadOfficeLocation } from "../../actions/userActions/officelocationAction";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import thIcon from "../../assets/images/thIcon.svg";
import AddOfficeLocations from './AddOfficeLocations'
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector'
import LoadingOverlay from '../loadingOverlay/LoadingOverlay'
import { t } from '../../locales/translate'
import { getCities } from "../../actions/userActions/cityAction";
import GenericFilter, { FilterBar } from "../subComponents/Filter/GenericFilters";
import CustomFilterSelect from "../designSystem/CustomFilterSelect";
const OFFICE_LOCATION_STATE_KEY = "officeLocationFiltersState";
const MODULE_FLAG = "insideOfficeLocationModule";
const OFFICE_LOCATION_ROUTES = [
    "/admin/officelocations",
    "/admin/addofficelocation",
    "/admin/updateofficelocation",
];

const isOfficeLocationModulePath = (path = "") =>
    OFFICE_LOCATION_ROUTES.some(route => path.toLowerCase().includes(route));
function OfficeLocations() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(1);
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [OfficeLocationsData, setOfficeLocationsData] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [cityFilter, setCityFilter] = useState('');
  const [headOfficeFilter, setHeadOfficeFilter] = useState('');
  const [isReady, setIsReady] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [citiesLoaded, setCitiesLoaded] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
 

  const officeLocations = useSelector(
    (state) => state.officeLocations_reducer.officeLocations,
  )
  const isLoading = useSelector((state) => state.officeLocations_reducer.isOfficeLocationsLoading);
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const totalPages = officeLocations?.totalPages || 0;
  const totalItems = officeLocations?.totalCount || 0;
  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const citydata = allCities?.result;
  const cityOptions = citydata?.map(city => ({
    id: city.id,
    name: city.name
  })) || [];

  const body = {
  filter: {
    textSearch: searchQuery,
    cityId: cityFilter ? parseInt(cityFilter) : null,
    isHeadOffice: headOfficeFilter === '' ? null : headOfficeFilter === 'true'
  },
  pageNumber: currentPage,
  pageSize: itemsPerPage,
}
 const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleCityFilterChange = (event) => {
    setCityFilter(event.target.value);
    setCurrentPage(1);
  };

  const handleHeadOfficeFilterChange = (event) => {
    setHeadOfficeFilter(event.target.value);
    setCurrentPage(1);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleClearAllFilters = () => {
    if (cityFilter === '' && headOfficeFilter === '') return;
    
    setCityFilter('');
    setHeadOfficeFilter('');
    setCurrentPage(1);
  };
  
  useEffect(() => {
    const clearModuleState = () => {
      sessionStorage.removeItem(MODULE_FLAG);
      localStorage.removeItem(OFFICE_LOCATION_STATE_KEY);
    };
    
    const unlisten = history.listen(({ pathname }) => {
      if (!isOfficeLocationModulePath(pathname)) {
        clearModuleState();
      }
    });

    return () => {
      unlisten();
      if (!isOfficeLocationModulePath(history.location.pathname)) {
        clearModuleState();
      }
    };
  }, [history]);

  useEffect(() => {
    const savedState = sessionStorage.getItem(MODULE_FLAG) === "true"
      ? JSON.parse(localStorage.getItem(OFFICE_LOCATION_STATE_KEY) || "null")
      : null;

    if (savedState) {
      setSearchQuery(savedState.search || '');
      setCurrentPage(savedState.page || 1);
      setItemsPerPage(savedState.pageSize || 10);
      setCityFilter(savedState.city || '');
      setHeadOfficeFilter(savedState.headOffice || '');
      setShowFilters(
        typeof savedState.showFilters === "boolean"
          ? savedState.showFilters
          : false
      );
    } else {
      setSearchQuery('');
      setCurrentPage(1);
      setItemsPerPage(10);
      setCityFilter('');
      setHeadOfficeFilter('');
      setShowFilters(false);
    }

    sessionStorage.setItem(MODULE_FLAG, "true");
    setIsReady(true);
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isReady) return;
    dispatch(getOfficeLocations(body));
  }, [currentPage, searchQuery, itemsPerPage, cityFilter, headOfficeFilter, isReady, dispatch]);

  useEffect(() => {
    if (isInitialized) {
      const filterState = {
        city: cityFilter,
        headOffice: headOfficeFilter,
        search: searchQuery,
        page: currentPage,
        pageSize: itemsPerPage,
        showFilters,
      };
      localStorage.setItem(OFFICE_LOCATION_STATE_KEY, JSON.stringify(filterState));
      sessionStorage.setItem(MODULE_FLAG, 'true');
    }
  }, [cityFilter, headOfficeFilter, searchQuery, currentPage, itemsPerPage, showFilters, isInitialized]);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const cityBody = {
          filter: { textSearch: '', countryId: '1' },
          pageNumber: -1,
          pageSize: 0,
        };

        dispatch(getCities(cityBody));
        setCitiesLoaded(true);
      } catch (error) {
        console.error('Error loading cities:', error);
      }
    };

    loadFilters();
  }, [dispatch]);
  const handleAddOfficeLocationClick = () => {
    setEditData(null);
    setShowModal(true);
  };


  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
  const body = {
    filter: {
      textSearch: searchQuery,
      cityId: cityFilter ? parseInt(cityFilter) : null,
      isHeadOffice: headOfficeFilter === '' ? null : headOfficeFilter === 'true'
    },
    pageNumber: currentPage,
    pageSize: itemsPerPage,
  };
    await dispatch(getOfficeLocations(body));
};
  useEffect(() => {
    const officeLocationData = officeLocations && officeLocations.result || [];
    const OfficeLocationData = officeLocationData?.map((officeLocations) => ({
      ...officeLocations,
      isHeadOffice: officeLocations.isHeadOffice ? "Yes" : "No",
    }));

    setOfficeLocationsData(OfficeLocationData);
  }, [officeLocations]);
  console.log(totalItems, 'items');

  const columns = [
    { label: `${t("address")}`, accessor: "address" },
    { label: `${t("city")}`, accessor: "cityName" },
    { label: `${t("contact")}`, accessor: "contact1" },
    { label: `${t("headOffice")}`, accessor: "isHeadOffice" },
  ];
  const handleEditOfficeLocation = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  const actions = [
    {
      label: 'Edit OfficeLocation',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdateOfficeLocation',
      handler: handleEditOfficeLocation,
    },
  ];
  const handleItemsPerPageChange = (value) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleOfficeLocationDownload = () => {
  const downloadBody = {
    filter: {
      textSearch: searchQuery,
      cityId: cityFilter ? parseInt(cityFilter) : null,
      isHeadOffice: headOfficeFilter === '' ? null : headOfficeFilter === 'true'
    },
    pageNumber: currentPage,
    pageSize: itemsPerPage,
  };

  dispatch(downloadOfficeLocation(downloadBody));
};

  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading && !showModal} />
        <div className="main-container">
          <div className="content-wrapper" style={{ padding: 0 }}>
            <div className="pagination" style={{ padding: '20px 16px' }}>
              <SearchInput
                placeholder="Search"
                onChange={handleSearchChange}
                value={searchQuery || ""}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: '80px', marginRight: '10px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
                <div style={{ paddingRight: '12px' }}>
                  <IconButton onClick={handleOfficeLocationDownload}>
                    <Download />
                  </IconButton>
                </div>
                <div style={{ marginRight: "12px" }}>
                  <GenericFilter
                    showFilters={showFilters}
                    toggleFilters={toggleFilters}
                  />
                </div>
                {permissions && permissions.includes("CanAddOfficeLocation") && (
                  <CustomButton text={t("addNew")} onClick={handleAddOfficeLocationClick} />
                )}
              </div>
            </div>

            <FilterBar
              showFilters={showFilters}
              onClearAll={handleClearAllFilters}
            >
              <div style={{ position: 'relative', zIndex: 102 }}>
                <CustomFilterSelect
                  label={t("city")}
                  value={cityFilter}
                  onChange={handleCityFilterChange}
                  options={[
                    { id: '', name: 'All' },
                    ...cityOptions
                  ]}
                  disabled={!citiesLoaded}
                  width="220px"
                  searchable={true}
                  searchPlaceholder="Search cities..."
                  noDataText="No cities available"
                />
              </div>
              <div style={{ position: 'relative', zIndex: 101 }}>
                <CustomFilterSelect
                  label={t("headOffice")}
                  value={headOfficeFilter}
                  onChange={handleHeadOfficeFilterChange}
                  options={[
                    { id: '', name: 'All' },
                    { id: 'true', name: 'Yes' },
                    { id: 'false', name: 'No' }
                  ]}
                  disabled={false}
                  width="220px"
                  searchable={false}
                />
              </div>
            </FilterBar>
          </div>

            <DynamicTable
              data={OfficeLocationsData}
              columns={columns}
              permissions={permissions}
              actions={actions}
              thIcon={thIcon}
              showPagination={totalItems > 0}
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>
        {showModal && (
          <AddOfficeLocations
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div>

    </>
  );
}

export default OfficeLocations
